import clsx from "clsx";
import { Link, LinkProps } from "react-router-dom";

type AppLinkProps = {
    children: React.ReactNode;
    className?: string;
} & LinkProps;

const AppLink = ({ children, className, ...props }: AppLinkProps) => {
    return (
        <Link
            {...props}
            className={clsx("underline text-deep-ocean-20", className)}
        >
            {children}
        </Link>
    );
};

export default AppLink;
